import { useGetTasksQuery } from 'redux-stores/tasks/tasksApi';
import type { Task } from 'js-sdk/src/types/Tasks';

export type TasksFilter = 'active' | 'completed';

type UseFilterTasksProps = {
  filter: TasksFilter;
  orgId?: string;
  skip: boolean;
};
const useFilterTasks = ({ filter, orgId, skip }: UseFilterTasksProps) => {
  const { data: tasks = [], isLoading } = useGetTasksQuery(orgId ?? '', {
    skip,
  });
  const filtered = isLoading
    ? []
    : tasks.filter((t: Task) =>
        filter === 'active' ? t.status === 'open' : t.status === 'completed'
      );
  return { tasks: filtered, isLoading };
};

export default useFilterTasks;
